export class CategoryAnchorNotFoundError extends Error { }
